module.exports = __webpack_public_path__ + "static/media/idea_done.791bec00.png";